import { useAtomValue } from 'jotai';
import React, { useEffect, useState } from 'react';
import { locationAtom } from '../store/location';
import { userAtom } from '../store/user';
import { ResaCalendarEvent } from './ResaCalendar';
import { FormattedDate, FormattedMessage } from 'react-intl';

export const ReadOnlyEvent = (props: {
	event: ResaCalendarEvent;
	close: () => void;
}) => {
	const [proxyEvent, setProxyEvent] = useState(props.event);
	useEffect(() => setProxyEvent(props.event), [props.event]);

	const location = useAtomValue(
		locationAtom(proxyEvent.resource.locationId ?? 0),
	);

	const needsApproval = location?.requiresApproval;
	const isApproved =
		proxyEvent.resource.anonymized || !!proxyEvent.resource.approved;

	return (
		<>
			<FormattedMessage
				defaultMessage="De: {date}"
				id="0bskdZ"
				values={{
					date: <FormattedDate timeZone="+02:00" value={props.event.start} timeStyle='short'/>,
				}}
			/>
			{' '}
			<FormattedMessage
				defaultMessage="À: {date}"
				id="zuXvY1"
				values={{
					date: <FormattedDate timeZone="+02:00" value={props.event.end} timeStyle='short' />,
				}}
			/>
			<br />
			{location && (
				<FormattedMessage
					defaultMessage="Lieu: {location}"
					id="1pjJDw"
					values={{ location: location?.post_title }}
				/>
			)}
			<br />
			<FormattedMessage
				defaultMessage="Participants: {participants}"
				id="h3BnRA"
				values={{
					participants: (
						<>
							{props.event.resource.users.map((u) => (
								<UserSpan key={u.userId} u={u} />
							))}
						</>
					),
				}}
			/>
			<br />
			{needsApproval && isApproved && (
				<span>
					<FormattedMessage
						defaultMessage="Votre réservation est approuvée, vous ne pouvez pas la modifier.
                         Vous pouvez annuler cette réservation pour en demander une nouvelle
                         mais vous ne serez pas prioritaire.
                         Vous pouvez contacter le staff via discord pour demander à modifier l'heure et les participants."
						id="5Lu+fi"
					/>
				</span>
			)}
			<br />
			{proxyEvent.resource.anonymized && (
				<span>
					<FormattedMessage
						defaultMessage="Note: les évenements auquels vous n'etes pas invité ne montrent pas le
					        lieux ni la liste complete des participants."
						id="MO3uLF"
					/>
				</span>
			)}
		</>
	);
};

const UserSpan = (props: { u: { userId: number } }) => {
	const user = useAtomValue(userAtom(props.u.userId));
	return <span>{user?.display_name}</span>;
};
